import { Progress } from 'antd';

export const MicrophoneLevel = ({ micLevel, isTranscriptTimeout }) => {
  const conicColors = {
    '0%': '#FF0000',
    '25%': '#E7EE00',
    '50%': '#E7EE00',
    '75%': '#3CE329',
    '100%': '#3CE329',
  };
  return (
    <div className="w-full flex justify-center items-center">
      {micLevel === 'offline' ? (
        <div className="text-[#667085]">Lost connection. Reconnecting...</div>
      ) : isTranscriptTimeout ? (
        <div className="text-orange-500">
          Are you speaking? We're not hearing you...
        </div>
      ) : (
        <Progress
          className="mb-0"
          percent={micLevel}
          strokeColor={conicColors}
          showInfo={false}
        />
      )}
    </div>
  );
};
